import {
  CREATE_POST_FAIL,
  CREATE_POST_REQUEST,
  CREATE_POST_SUCCESS,
  GET_POST_FAIL,
  GET_POST_REQUEST,
  GET_POST_SUCCESS,
  GET_SINGLE_POST_FAIL,
  GET_SINGLE_POST_REQUEST,
  GET_SINGLE_POST_SUCCESS,
} from '../actions/actionType';

const initState = {
  loading: false,
  msg: '',
  posts: [],
  error: null,
};

const _blogReducer = (state = initState, action) => {
  switch (action.type) {
    case CREATE_POST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_POST_SUCCESS:
      return {
        ...state,
        loading: false,
        msg: action.payload,
      };
    case CREATE_POST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_POST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_POST_SUCCESS:
      return {
        ...state,
        loading: false,
        posts: action.payload,
      };
    case GET_POST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_SINGLE_POST_REQUEST:
      return {
        loading: true,
      };

    case GET_SINGLE_POST_SUCCESS:
      return { loading: false, singlePost: action.payload, error: null };

    case GET_SINGLE_POST_FAIL:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default _blogReducer;
